import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FormMode, Languages, ServiceStatus } from 'src/app/shared/models/enums.model';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { User } from 'src/app/front-user/shared/models/user.model';
import { TransitAdminDto } from '../../shared/models/transit-admin.model';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { TransitRequestComponent } from 'src/app/front-user/services/e-booking/transit-request/transit-request.component';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TransitAdminService } from '../../shared/services/transit-admin.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { ResponseObject } from 'src/app/shared/models/response-object.model';

@Component({
  selector: 'app-measurement-confirm-pending-documents',
  templateUrl: './measurement-confirm-pending-documents.component.html',
  styleUrls: ['./measurement-confirm-pending-documents.component.css']
})
export class MeasurementConfirmPendingDocumentsComponent implements OnInit {

  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  confirmDocumentsForm: FormGroup;
  displayedLang: Languages;
  baseRequestId: string = '';
  requestStatus: number;
   baseRequestDTO: BaseRequest //= new BaseRequest();
  submitted: boolean = false;
  user: User = new User();
  showRequest: boolean = false;
  adminDecisionObject: TransitAdminDto = new TransitAdminDto();
  @ViewChild('transitRequest',{static: false}) transitRequest: TransitRequestComponent;
  isErrorMessage: boolean = false;
  lockTaskErrorMessage: boolean = false;
  constructor(private formBuilder: FormBuilder, private baseRequestService: BaseRequestService,
    private globalSrv: GlobalServices,
    private route: ActivatedRoute, private router: Router,
    private translate: TranslateService, private adminSrv: TransitAdminService,
    private authenticationService: AuthenticationService, private alertService: AlertService) {
    this.displayedLang = this.globalSrv.getLanguage()
    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;
      this.getBaseRequest();
    }else{
      window.history.back();
    }

    this.user = this.authenticationService.currentUserValue;
    // this.baseRequestId = '47F8B6D4-7F34-4234-8377-35262235A57A';

  }

  ngOnInit() {
    this.buildForm();
  }

  buildForm() {
    this.confirmDocumentsForm = this.formBuilder.group({
      Accepted: ['', [Validators.requiredTrue]],
    });

  }
  getBaseRequest() {
    this.baseRequestService.getBaseRequest(this.baseRequestId).subscribe(
      d => {
        this.baseRequestDTO = d.Data;
        this.requestStatus = this.baseRequestDTO.StatusId;
        if (this.requestStatus == ServiceStatus.PendingOnDocumentConfirmation) {
          this.formMode = FormMode.Add;
          this.confirmDocumentsForm.enable();

        }
        else if (history.state.data && history.state.data.isCompleted) {
          this.confirmDocumentsForm.patchValue({
            Accepted: true,

          });
          this.formMode = FormMode.Readonly;
          this.confirmDocumentsForm.disable();
        }
        else {
          this.confirmDocumentsForm.patchValue({
            Accepted: true,

          });
          this.formMode = FormMode.Readonly;
          this.confirmDocumentsForm.disable();
        }

      }
    )
  }

  get f() {
    return this.confirmDocumentsForm.controls;
  }


  onSubmit(b) {

    this.submitted = true;
    // stop here if form is invalid
    if (this.confirmDocumentsForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    //this.adminDecisionObject = this.marineAcceptanceForm.value;
    this.adminDecisionObject.AdminEmail = this.user.UserName;
    this.adminDecisionObject.RequestId = this.baseRequestId;

    this.adminSrv.confirmPendingDocuments(this.adminDecisionObject)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            this.confirmDocumentsForm.reset();
            this.showRequest = true;
            this.isErrorMessage = false;
          } else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          } else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            //this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + data.ErrorMessages[0]));
          }

        });
  }


}
